import makeStyles from '@mui/styles/makeStyles'

export const useStyles = makeStyles(({ breakpoints, spacing, typography, palette }) => ({
  // root: {
  //   display: 'flex',
  //   height: '100vh',
  //   justifyContent: 'space-between',
  //   '& .MuiDrawer-paper': {
  //     maxWidth: 425,
  //     width: '100%'
  //     // padding: spacing(0, 3)
  //   }
  // },
  title: {
    ...typography.body.m,
    ...typography.weight.bold,
    display: 'flex',
    padding: spacing(5, 5),
    justifyContent: 'space-between',
    alignItems: 'center',
    '& .MuiButton-root': {
      justifyContent: 'flex-end'
    }
  },
  subtitle: {
    padding: spacing(3, 5)
  },
  footer: {
    width: '100%',
    padding: spacing(3, 3),
    marginTop: 'auto',
    borderTop: `1px solid ${palette.grey.shade[5]}`,
    backgroundColor: 'white',
    zIndex: 2,
    '& .MuiTypography-root': {
      marginBottom: spacing(3)
    }
  },
  stepper: {
    [breakpoints.up('sm')]: {
      padding: spacing(0, 5)
    }
  },
  content: {
    flexDirection: 'column',
    gap: spacing(2),
    padding: spacing(0, 5)
  },
  overflow: {
    overflowY: 'auto',
    overflowX: 'hidden',
    // hidden overflow magic
    '-ms-overflow-style': 'none', // IE 10+
    overflow: '-moz-scrollbars-none', // Firefox
    '&::-webkit-scrollbar': {
      display: 'none' // Safari and Chrome
    }
  }
}))
